var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`pa-4 text-${_vm.align}`,style:(`background-color: ${_vm.backgroundColor}; border-radius: 5px;`)},[_c('span',{staticClass:"d-block title font-weight-bold"},[_vm._v(_vm._s(_vm.title))]),(_vm.subtitle)?_c('span',{staticClass:"d-block body-2"},[_vm._v(_vm._s(_vm.subtitle))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }